import PropTypes from "prop-types";
import React from "react";

import PageBody from "@components/PageBody";
import Report from "@components/Report";
import settings from "@settings/index";
import AdminPageTemplate from "@templates/AdminPage";

function Inbox(props) {
  return (
    <AdminPageTemplate breadcrumbs={props.breadcrumbs}>
      <PageBody title="Caixa de Entrada">
        <Report quickSightID={settings.reports.INBOX} />
      </PageBody>
    </AdminPageTemplate>
  );
}

Inbox.propTypes = {
  breadcrumbs: PropTypes.array,
};

Inbox.defaultProps = {
  breadcrumbs: [],
};

export default Inbox;
